<template>
  <b-nav-item-dropdown
    class="dropdown-notification mr-75"
    menu-class="dropdown-menu-media dropdown-menu-right"
    left
  >
    <template #button-content>
      <feather-icon
        :badge="notifications.length"
        badge-classes="bg-danger"
        class="text-body"
        icon="HelpCircleIcon"
        size="21"
        v-b-tooltip.hover.button.viewport="`${$t('helpdesk.title')}`"
      />
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">
          <router-link :to="{ name: 'helpdesk_ticket' }">
              <feather-icon icon="LinkIcon" />
              <span class="align-middle ml-50">{{ $tc("helpdesk.ticket.title", 2) }}</span>
          </router-link>
        </h4>
        <div>
          <b-button
            v-if="$can('create', 'HelpdeskTicket')"
            v-b-modal.create_ticket_modal
            size="sm"
            variant="info"
            style="margin-right: 5px"
          >
            {{ $t("helpdesk.ticket.create_ticket") }}
          </b-button>
          <b-badge pill variant="light-primary">
            {{ `${notifications.length} ${$tc("helpdesk.ticket.title", 2)}` }}
          </b-badge>
        </div>
      </div>
    </li>

    <!-- Notifications -->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="scrollable-container media-list scroll-area"
      tagname="li"
    >
      <!-- Account Notification -->
      <b-link v-for="notification in notifications" :key="notification.id">
        <b-media
          @click="openTicket(notification)"
          draggable
          @dragstart="onDragStart(notification)"
          @dragend="onDragEnd"
        >
          <template #aside>
            <b-avatar size="32">
              <span class="d-flex align-items-center">
                <feather-icon
                  :icon="notification.error ? 'CollectionIcon' : 'FileIcon'"
                  size="16"
                />
              </span>
            </b-avatar>
          </template>
          <p class="media-heading">
            <span class="font-weight-bolder">
              {{ `${notification.title}` }}
              <small class="notification-text float-right">{{
                notification.timestamp
              }}</small>
            </span>
          </p>
          <small class="notification-text">{{ notification.body }}</small>
          <p class="media-heading">
            <small class="notification-text">
              <b-badge pill variant="light-primary">
                {{ notification.tag }}
              </b-badge>
            </small>
          </p>
        </b-media>
      </b-link>
    </vue-perfect-scrollbar>
    <create-ticket-modal/>
  </b-nav-item-dropdown>
</template>

<script>
import { BNavItemDropdown } from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import store from "@/store";
import { computed } from "@vue/composition-api";
import LayoutApi from "@/libs/LayoutApi.js";
import { SLOT_TYPES } from "@/config/layoutConfig";
import CreateTicketModal from "@/views/components/GridView/layouts/slots/HelpdeskSlot/CreateTicketModal.vue";
import { decryptData } from "@/utils/decryptUserDataUtils";

const layoutApi = new LayoutApi(store);

export default {
  components: {
    BNavItemDropdown,
    VuePerfectScrollbar,
    CreateTicketModal,
  },
  setup() {
    const user = JSON.parse(decryptData(window.localStorage.userData));
    let userId = user.id;

    store.dispatch("helpdesk_ticket/getAssigned", {assigned: userId, id_user: userId})
    let notifications = computed(
      () => store.getters["helpdesk_ticket/getItemsTicketOpen"]
    );

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    };

    const openTicket = async (ticket) => {
      layoutApi.setSlotData(SLOT_TYPES.HELPDESK, `HELPDESK`, {
        data: ticket,
      });
      store.dispatch("grid/updateUserConfig");
    };

    const onDragStart = (ticket) => {
      openTicket(ticket);
    };
    const onDragEnd = () => {};

    return {
      notifications,
      perfectScrollbarSettings,
      openTicket,
      onDragStart,
      onDragEnd,
    };
  },
};
</script>

<style></style>
